<div
  class="mt-2 d-flex align-items-center"
  [ngClass]="{ report: isReport }"
>
  <span class="pr-2">{{ 'COMMON.CUSTOM_PERIOD' | translate }}</span>
  <i
    class="far fa-calendar calendar-view-icon custom-date-range-icon"
    [attr.aria-label]="'IMAGE_DESCRIPTION.CUSTOM_PERIOD_SELECTION' | translate"
    role="img"></i>
  <div
    class="px-2 font-size-small custom-date-range-input text-primary"
    #rangeDates
    [outsideClick]="true"
    [popover]="popoverTemplate"
    [placement]="isReport ? 'right' : 'left top'"
    [adaptivePosition]="true"
    containerClass="custom-date-range-container"
  >
    {{ start | dateTimeFormatPipe: dateTimeFormat }} - {{ end | dateTimeFormatPipe: dateTimeFormat }}
  </div>
</div>

<ng-template #popoverTemplate>
  <div class="row mt-2">
    <div
      class="warn-message col-12 d-flex justify-content-center text-primary"
      [innerHtml]="warnMessage | translate"
    ></div>
  </div>
  @if (bsRangeValue) {
    <div class="row">
      <bs-daterangepicker-inline
        [bsConfig]="bsConfig | async"
        [bsValue]="bsRangeValue"
        [minDate]="minTime"
        [maxDate]="maxTime"
        [maxDateRange]="maxDateRange"
        (bsValueChange)="bsValueChange($event)"
      ></bs-daterangepicker-inline>
    </div>
  }
  <div class="row custom-date-range-time">
    <div class="col d-flex align-items-center justify-content-center">
      <span>{{ 'COMMON.START_TIME' | translate }}:</span>
      <timepicker
        [(ngModel)]="startTime"
        [showMeridian]="isMeridian"
        [showSpinners]="showSpinners"
        [minuteStep]="10"
        (ngModelChange)="timeStartChanged($event)"
      ></timepicker>
    </div>
    <div class="col d-flex align-items-center justify-content-center">
      <span>{{ 'COMMON.END_TIME' | translate }}:</span>
      <timepicker
        [(ngModel)]="endTime"
        [showMeridian]="isMeridian"
        [showSpinners]="showSpinners"
        [minuteStep]="10"
        (ngModelChange)="timeEndChanged($event)"
      ></timepicker>
    </div>
  </div>
  @if (showLastDataPointWarning && !isReport) {
    <div class="row mb-2 justify-content-end">
      <div class="col d-flex align-items-center justify-content-center"></div>
      <div class="col d-flex align-items-center justify-content-center">
        <small
          class="text-red warn-message"
          [innerHtml]="'COMMON.LAST_POINT_WARN_MESSAGE' | translate"
        ></small>
      </div>
    </div>
  }
  <div class="row mb-2">
    <div class="col-12 d-flex justify-content-end">
      <lib-button
        id="apply-button-daterangepicker"
        [size]="'small'"
        [label]="'COMMON.APPLY' | translate"
        [disabled]="!isValidRange"
        (buttonClicked)="onApply()"
      ></lib-button>
    </div>
  </div>
</ng-template>
